<template>
	<div class="login-view">
		<!-- 左侧 hero 展示区 -->
		<div class="auth-hero">
			<div class="hero-brand">
				<img class="hero-logo" src="/logo.png" alt="比特IM" onerror="this.style.display='none'" />
				<span class="hero-brand-name">比特IM 管理端</span>
			</div>
			<h1 class="hero-title">专业、安全的<br />即时通讯管理控制台</h1>
			<p class="hero-sub">统一管理用户、群组、内容与站点配置，私有化部署，数据由您掌控。</p>
			<ul class="hero-features">
				<li v-for="(f, i) in heroFeatures" :key="i">
					<i :class="f.icon"></i>
					<div class="hf-text"><b>{{ f.t }}</b><span>{{ f.d }}</span></div>
				</li>
			</ul>
			<div class="hero-foot">© {{ year }} 比特IM · 管理控制台</div>
		</div>

		<!-- 右侧登录模块 -->
		<div class="auth-panel">
			<div class="auth-bg">
				<div class="auth-bg__base"></div>
				<div class="auth-bg__glows"></div>
				<div class="auth-bg__dots"></div>
			</div>
			<div class="auth-panel__inner">
				<el-form class="form" :model="loginForm" status-icon :rules="rules" ref="loginForm"
					@keyup.enter.native="submitForm('loginForm')">
					<div class="form-header">
						<h1 class="form-welcome">欢迎登录</h1>
						<p class="form-welcome-subtitle">管理端 · 一站式即时通讯解决方案</p>
					</div>
					<div class="form-body">
						<el-form-item prop="terminal" v-show="false">
							<el-input type="terminal" v-model="loginForm.terminal" autocomplete="off"></el-input>
						</el-form-item>
						<el-form-item prop="userName">
							<el-input type="userName" v-model="loginForm.userName" autocomplete="username" placeholder="用户名"
								prefix-icon="el-icon-user"></el-input>
						</el-form-item>
						<el-form-item prop="password">
							<el-input type="password" v-model="loginForm.password" autocomplete="current-password"
								placeholder="密码" prefix-icon="el-icon-lock"></el-input>
						</el-form-item>
						<el-form-item prop="captchaCode" class="captcha-item">
							<el-input v-model="loginForm.captchaCode" autocomplete="off" placeholder="验证码"
								maxlength="4" prefix-icon="el-icon-key"></el-input>
							<img v-if="captchaImage" class="captcha-img" :src="captchaImage" title="点击刷新"
								@click="loadCaptcha" />
							<div v-else class="captcha-img captcha-loading" @click="loadCaptcha">加载中</div>
						</el-form-item>
						<el-form-item class="nav-tool-bar">
							<el-checkbox v-model="isAutoLogin">自动登录</el-checkbox>
						</el-form-item>
						<el-button class="submit-btn" type="primary" :loading="submitting"
							@click="submitForm('loginForm')">登录</el-button>
					</div>
				</el-form>
			</div>
			<icp></icp>
		</div>
	</div>
</template>

<script>
import Icp from '../components/common/Icp.vue'
import * as auth from '../api/auth.js'

export default {
	name: "login",
	components: {
		Icp
	},
	data() {
		var checkUsername = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入用户名'));
			}
			callback();
		};
		var checkPassword = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入密码'));
			}
			callback();

		};
		return {
			year: new Date().getFullYear(),
			heroFeatures: [
				{ icon: 'el-icon-user', t: '用户与群组', d: '账号、好友、群聊统一管理' },
				{ icon: 'el-icon-s-tools', t: '系统配置', d: '全局参数一键设定' },
				{ icon: 'el-icon-monitor', t: '站点官网', d: '可视化配置官网内容' },
				{ icon: 'el-icon-lock', t: '安全合规', d: '私有化部署可审计' }
			],
			loginForm: {
				terminal: this.$enums.TERMINAL_TYPE.WEB,
				userName: '',
				password: '',
				captchaUuid: '',
				captchaCode: ''
			},
			captchaImage: '',
			isAutoLogin: true,
			submitting: false,
			rules: {
				userName: [{
					validator: checkUsername,
					trigger: 'blur'
				}],
				password: [{
					validator: checkPassword,
					trigger: 'blur'
				}],
				captchaCode: [{
					validator: (rule, value, callback) => {
						if (!value) {
							return callback(new Error('请输入验证码'));
						}
						callback();
					},
					trigger: 'blur'
				}]
			}
		};
	},
	methods: {
		loadCaptcha() {
			this.loginForm.captchaCode = '';
			this.$http({
				url: "/captcha/image",
				method: 'get'
			}).then((data) => {
				this.captchaImage = data.image;
				this.loginForm.captchaUuid = data.uuid;
			});
		},
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (!valid) {
					return;
				}
				if (!this.loginForm.captchaCode) {
					return this.$message.warning("请输入验证码");
				}
				this.submitting = true;
				this.$http({
					url: "/login",
					method: 'post',
					data: this.loginForm
				}).then((data) => {
					auth.saveLoginSession(data, {
						autoLogin: this.isAutoLogin,
						userName: this.loginForm.userName
					});
					// 纯管理端:校验管理员身份(type=0),普通用户拒绝进入
					return this.$http({
						url: "/user/self",
						method: 'get'
					}).then((userInfo) => {
						if (userInfo.type !== 0) {
							auth.clearLoginSession(true);
							this.$message.error("该账号没有管理权限,请使用管理端账号登录");
							return;
						}
						this.$message.success("登录成功");
						this.$router.push("/admin/system");
					});
				}).catch(() => {
					// 登录失败刷新验证码
					this.loadCaptcha();
				}).finally(() => {
					this.submitting = false;
				});
			});
		},
		tryTokenAutoLogin() {
			if (!auth.isAutoLoginEnabled()) {
				return;
			}
			this.submitting = true;
			auth.refreshLogin(this.$http).then(async () => {
				const userInfo = await this.$http({
					url: "/user/self",
					method: 'get'
				}).catch(() => null);
				if (!userInfo || userInfo.type !== 0) {
					auth.clearLoginSession(true);
					this.isAutoLogin = false;
					this.$message.error("该账号没有管理权限");
					return;
				}
				this.$router.push("/admin/system");
			}).catch(() => {
				auth.clearLoginSession(true);
				this.isAutoLogin = false;
			}).finally(() => {
				this.submitting = false;
			});
		}
	},
	mounted() {
		auth.removeLegacyPassword();
		if (localStorage.getItem("isAutoLogin") != null) {
			this.isAutoLogin = auth.isAutoLoginEnabled();
		}
		this.loginForm.userName = auth.getSavedUsername();
		this.loadCaptcha();
		this.tryTokenAutoLogin();
	}
}
</script>

<style scoped lang="scss">
.login-view {
	position: relative;
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	display: flex;
	overflow: hidden;
	background: #fff;

	/* ===== 左侧 hero ===== */
	.auth-hero {
		position: relative;
		flex: 1.1;
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding: 56px 60px;
		color: #fff;
		background:
			radial-gradient(820px 440px at 88% -8%, rgba(53, 201, 124, 0.4), transparent 60%),
			radial-gradient(680px 420px at -8% 110%, rgba(22, 164, 92, 0.45), transparent 60%),
			linear-gradient(150deg, #0B5C31 0%, #0E7A43 55%, #16A45C 100%);
		overflow: hidden;

		&::after {
			content: '';
			position: absolute;
			inset: 0;
			background-image: linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),
				linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
			background-size: 40px 40px;
			mask-image: radial-gradient(620px 420px at 65% 35%, #000 0%, transparent 78%);
			pointer-events: none;
		}
	}

	.hero-brand {
		display: flex;
		align-items: center;
		gap: 12px;
		margin-bottom: 38px;
		z-index: 1;

		.hero-logo {
			width: 44px;
			height: 44px;
			border-radius: 12px;
			background: rgba(255, 255, 255, 0.16);
			padding: 4px;
		}

		.hero-brand-name {
			font-size: 22px;
			font-weight: 800;
			letter-spacing: 0.5px;
		}
	}

	.hero-title {
		position: relative;
		z-index: 1;
		margin: 0 0 16px;
		font-size: 36px;
		line-height: 1.3;
		font-weight: 800;
		letter-spacing: -0.3px;
		max-width: 460px;
	}

	.hero-sub {
		position: relative;
		z-index: 1;
		margin: 0 0 34px;
		font-size: 15.5px;
		line-height: 1.8;
		color: rgba(255, 255, 255, 0.82);
		max-width: 430px;
	}

	.hero-features {
		position: relative;
		z-index: 1;
		list-style: none;
		margin: 0;
		padding: 0;
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 18px 24px;
		max-width: 460px;

		li {
			display: flex;
			align-items: flex-start;
			gap: 12px;

			i {
				flex-shrink: 0;
				width: 38px;
				height: 38px;
				border-radius: 11px;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 19px;
				background: rgba(255, 255, 255, 0.14);
			}

			.hf-text {
				b {
					display: block;
					font-size: 15px;
					font-weight: 700;
				}

				span {
					font-size: 12.5px;
					color: rgba(255, 255, 255, 0.72);
					line-height: 1.5;
				}
			}
		}
	}

	.hero-foot {
		position: relative;
		z-index: 1;
		margin-top: 40px;
		font-size: 12.5px;
		color: rgba(255, 255, 255, 0.6);
	}

	/* ===== 右侧登录模块 ===== */
	.auth-panel {
		position: relative;
		width: 460px;
		flex-shrink: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #fff;
	}

	.auth-bg {
		position: absolute;
		inset: 0;
		pointer-events: none;
		overflow: hidden;

		.auth-bg__base {
			position: absolute;
			inset: 0;
			background: linear-gradient(180deg, #F6FAF8 0%, #fff 100%);
		}

		.auth-bg__glows {
			position: absolute;
			inset: 0;
			background-image:
				radial-gradient(ellipse 60% 45% at 90% 8%, rgba(22, 164, 92, 0.08) 0%, transparent 55%),
				radial-gradient(ellipse 50% 40% at 5% 95%, rgba(14, 122, 67, 0.06) 0%, transparent 50%);
		}

		.auth-bg__dots {
			position: absolute;
			inset: 0;
			opacity: 0.35;
			background-image: radial-gradient(circle, rgba(14, 122, 67, 0.08) 1px, transparent 1px);
			background-size: 22px 22px;
		}
	}

	.auth-panel__inner {
		position: relative;
		z-index: 1;
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 24px 44px 10px;
	}

	.form {
		width: 100%;
		max-width: 360px;
		display: flex;
		flex-direction: column;
	}

	.form-header {
		flex-shrink: 0;
		text-align: left;
		margin-bottom: 20px;
	}

	.form-welcome {
		margin: 0 0 6px;
		font-size: 26px;
		font-weight: 700;
		letter-spacing: 0.5px;
		line-height: 1.3;
		color: var(--im-color-primary);
	}

	.form-welcome-subtitle {
		margin: 0;
		font-size: var(--im-font-size);
		color: var(--im-text-color-light);
		line-height: 1.5;
	}

	.form-body {
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: center;
		min-height: 0;
	}

	.form-body ::v-deep .el-form-item {
		margin-bottom: 20px;

		.el-input__inner {
			height: 52px;
			border-radius: 50px;
			border: 1px solid rgba(0, 0, 0, 0.06);
			background: #fff;
			transition: border-color 0.2s ease, box-shadow 0.2s ease;
			padding-left: 48px;
			font-size: var(--im-font-size-large);

			&:focus {
				border-color: rgba(14, 122, 67, 0.4);
				box-shadow: 0 0 0 3px rgba(14, 122, 67, 0.1);
			}

			&::placeholder {
				color: var(--im-text-color-lighter);
				font-size: var(--im-font-size);
			}
		}

		.el-input__prefix {
			left: 18px;
		}

		.el-input__prefix .el-input__icon {
			color: var(--im-color-primary-light-3);
			font-size: 18px;
		}

		.el-input__suffix {
			display: none;
		}
	}

	// 图文验证码行
	.captcha-item {
		::v-deep .el-input__inner {
			padding-left: 48px;
		}

		.captcha-img {
			position: absolute;
			right: 6px;
			top: 6px;
			width: 118px;
			height: 40px;
			border-radius: 40px;
			cursor: pointer;
			z-index: 1;
		}

		.captcha-loading {
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 12px;
			color: #93a099;
			background: #f2f6f3;
		}
	}

	.submit-btn {
		width: 100%;
		height: 52px;
		margin-top: 20px;
		border-radius: 50px;
		border: none;
		color: #fff;
		font-size: var(--im-font-size-larger);
		font-weight: 600;
		letter-spacing: 2px;
		background: linear-gradient(135deg, #16A45C, #0E7A43);
		transition: transform 0.2s ease, box-shadow 0.2s ease;

		&:hover {
			transform: translateY(-1px);
			box-shadow: 0 10px 24px rgba(14, 122, 67, 0.3);
		}
	}
}

@media (max-width: 960px) {
	.login-view {
		.auth-hero {
			display: none;
		}

		.auth-panel {
			width: 100%;
		}
	}
}
</style>
